import { render } from "./PokemonOption.vue?vue&type=template&id=2a6d3b00&scoped=true"
import script from "./PokemonOption.vue?vue&type=script&lang=js"
export * from "./PokemonOption.vue?vue&type=script&lang=js"

import "./PokemonOption.vue?vue&type=style&index=0&id=2a6d3b00&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6d3b00"]])

export default __exports__